import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import type {
  ConductorCreativeItineraryInlinePlusFields,
  CreativeItineraryInlinePlus,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getItineraryInlinePlusCreative = (
  fields: ConductorCreativeItineraryInlinePlusFields,
): CreativeItineraryInlinePlus => {
  // We need to build up a new object because flow cannot infer the type after a spread.
  // See https://github.com/facebook/flow/issues/6108
  const {
    appIndex,
    backgroundColour,
    callToActionText = null,
    carriersCriteria,
    checkoutType,
    deeplink = null,
    dimensions,
    excludedCarriers,
    headline,
    includedCarriers,
    itineraryId,
    message,
    moreInfoLabel,
    moreInfoTarget,
    partner,
    partnerLogo,
    partnerType,
    pioAgencyName,
    pioPartnerName,
    redirectUrl,
    requestedDepth,
    selection,
    showMoreInfo,
    splitTestId,
    subHeadline,
    textColour,
    trackingModifications,
    transferType,
    useFlightsSkippyChannel,
  } = fields;

  return {
    appIndex,
    backgroundColour,
    callToActionText,
    deeplink,
    format: ADVERT_FORMAT_TYPES.ITINERARY_INLINE_PLUS,
    headline,
    itineraryId,
    message,
    moreInfoLabel,
    moreInfoTarget,
    partner,
    partnerLogo,
    partnerType,
    redirectUrl,
    requestedDepth,
    showMoreInfo: (showMoreInfo || '').toLowerCase() === 'true',
    subHeadline,
    textColour,
    checkoutType,
    dimensions,
    trackingModifications,
    transferType,
    useFlightsSkippyChannel,
    selection,
    carriersCriteria: carriersCriteria || 'all',
    includedCarriers: includedCarriers ? includedCarriers.split(',').map(Number) : [],
    excludedCarriers: excludedCarriers ? excludedCarriers.split(',').map(Number) : [],
    splitTestId,
    pioPartnerName,
    pioAgencyName,
  };
};
